/** Jump-course catalog. Strips are 70 px wide and tile side by side over a `spikes` zone;
 * hanging strips mount top-centre on a wall's underside (`ceiling`). */
export const COURSE_PROP_TEMPLATES = {
  spike_strip: { kind: 'trinket', name: 'spike strip', frame: { w: 70, h: 16 }, band: 'vegetation' },
  spike_strip_hanging: { kind: 'trinket', name: 'hanging spike strip', frame: { w: 70, h: 16 }, band: 'architecture', attachment: 'ceiling' },
} as const;
